/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-29 17:34:06
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-06-08 14:08:59
 */
import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

//去除权限控制

// import Vue from 'vue'
// import Router from 'vue-router'
// import { constantRouterMap, asyncRouterMap } from '@/config/router.config'

// Vue.use(Router)

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   scrollBehavior: () => ({ y: 0 }),
//   routes: constantRouterMap.concat(asyncRouterMap)
// })


// WEBPACK FOOTER //
// ./src/router/index.js